import React from 'react'
import GiftCardDetailsPage from '../../components/User/GiftCardDetailsPage';

const GiftCardDetailsComp = () => {
  return (
    <GiftCardDetailsPage />
  )
}

export default GiftCardDetailsComp;